import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Session/Login.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: Login,  meta: { requiresAuth: false } },

  { path: '/', component: (resolve) => {
    require.ensure(['../views/Dashboard/Index.vue'], () => {
      resolve(require('../views/Dashboard/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/leads', component: (resolve) => {
      require.ensure(['../views/Leads/Index.vue'], () => {
        resolve(require('../views/Leads/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/leads/form', component: (resolve) => {
      require.ensure(['../views/Leads/Form/Index.vue'], () => {
        resolve(require('../views/Leads/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/whatsapp', component: (resolve) => {
      require.ensure(['../views/WhatsApp/Index.vue'], () => {
        resolve(require('../views/WhatsApp/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/payments', component: (resolve) => {
      require.ensure(['../views/PaymentsAndSubscriptions/Index.vue'], () => {
        resolve(require('../views/PaymentsAndSubscriptions/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/tenants', component: (resolve) => {
      require.ensure(['../views/Tenants/Index.vue'], () => {
        resolve(require('../views/Tenants/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/tenants/form', component: (resolve) => {
      require.ensure(['../views/Tenants/Form/Index.vue'], () => {
        resolve(require('../views/Tenants/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/changepassword', component: (resolve) => {
      require.ensure(['../views/Session/ChangePassword.vue'], () => {
        resolve(require('../views/Session/ChangePassword.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '*', component: (resolve) => {
      require.ensure(['../views/Error404.vue'], () => {
        resolve(require('../views/Error404.vue'))
      })
  },  meta: { requiresAuth: true } }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js